/* eslint-disable react/no-array-index-key */
import useEmblaCarousel from 'embla-carousel-react'
import Autoplay from 'embla-carousel-autoplay'
import { Trans, useLingui } from '@lingui/react/macro'

import { H2 } from '../../_components/H2'

import { getLocalizedIndexImage, whoIsImages } from './localizedImages'

import LazyImage from '@/components/LazyImage'
import { useEmblaCarouselDotButton } from '@/hooks/emblaCarousel'
import { useLocale } from '@/hooks/routes'


import { cls } from 'tagged-classnames-free';
export const WhoIs: React.FC = () => {
  const { t } = useLingui()
  const locale = useLocale()

  const list = [
    {
      title: t`Musicians`,
      desc: (
        <Trans>
          Create original songs that align with your artistic vision, providing
          a solid foundation for your next album or live performance.
        </Trans>
      ),
      img: getLocalizedIndexImage(
        locale,
        '/images/index/musicians.jpg',
        whoIsImages.musicians,
      ),
    },
    {
      title: t`Video content creators`,
      desc: (
        <Trans>
          Produce high-quality, royalty-free AI songs as background music for
          your video to captivate your audience on platforms like YouTube,
          TikTok and Instagram.
        </Trans>
      ),
      img: getLocalizedIndexImage(
        locale,
        '/images/index/video-content.jpg',
        whoIsImages.videoContentCreators,
      ),
    },
    {
      title: t`Businesses`,
      desc: (
        <Trans>
          Create professional AI songs tailored for advertisements, promotional
          materials and e-commerce to attract more customers.
        </Trans>
      ),
      img: getLocalizedIndexImage(
        locale,
        '/images/index/businesses.jpg',
        whoIsImages.businesses,
      ),
    },
    {
      title: t`Hobbyists and casual users`,
      desc: (
        <Trans>
          Explore your creativity by generating fun and original songs for
          personal projects, events, or just for enjoyment.
        </Trans>
      ),
      img: getLocalizedIndexImage(
        locale,
        '/images/index/hobbyists.jpg',
        whoIsImages.hobbyists,
      ),
    },
  ]
  const [emblaRef, emblaApi] = useEmblaCarousel(
    { loop: true, watchDrag: false },
    [Autoplay()],
  )
  const { selectedIndex, onDotButtonClick } =
    useEmblaCarouselDotButton(emblaApi)

  return (
    <div className='mx-auto max-w-[1112px] px-4'>
      <H2 className='font-normal lg:font-bold'>
        <Trans>Who Is Tad AI Music Generator Best For?</Trans>
      </H2>
      <p className='text-f-other-10 mx-auto pt-2 text-center text-sm md:max-w-[800px] md:pt-3 md:text-xl'>
        <Trans>
          Tad.ai makes music creation accessible and enjoyable. See how you can
          benefit from our AI song generator.
        </Trans>
      </p>
      <div className='bg-f-bg-container mt-6 overflow-hidden rounded-2xl p-4 md:mt-12 md:px-16 md:py-9'>
        <div ref={emblaRef} className='overflow-hidden'>
          <div className='flex'>
            {list.map((item) => {
              return (
                <div
                  key={item.title}
                  className='me-5 flex flex-[0_0_100%] flex-col-reverse items-center gap-6 md:flex-row md:gap-16'
                >
                  <div className='flex-1'>
                    <h3 className='font-semibold md:text-4xl'>{item.title}</h3>
                    <p className='text-f-other-10 pt-2 text-sm md:pt-6 md:text-base'>
                      {item.desc}
                    </p>
                    <div className='flex items-center gap-1 pt-8 md:pt-20'>
                      {Array.from({ length: list.length }).map(
                        (item, index) => {
                          return (
                            <span
                              onClick={() => onDotButtonClick(index)}
                              key={index}
                              className={cls`${selectedIndex === index ? 'bg-f-primary w-8' : 'bg-f-text-quaternary w-5'} h-1.5 cursor-pointer rounded-full`}
                            ></span>
                          )
                        },
                      )}
                    </div>
                  </div>
                  <LazyImage
                    width={514}
                    height={360}
                    src={item.img}
                    alt={item.title}
                    className='rounded-lg'
                  />
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )
}
